export interface AverageTimePerAssetLabel {
  label: string;
  /** Erklärt die Rechnung: Projektstunden ÷ gewartete Objekte. */
  detail: string;
}

function formatDecimalHours(hours: number): string {
  const rounded = Math.round(hours * 10) / 10;
  return `${rounded.toFixed(1).replace(".", ",")} h`;
}

/** Lesbare Dauer für einen Durchschnitt, z. B. „18 min“ oder „1 h 12 min“. */
export function formatAverageDuration(hours: number): string {
  const totalMinutes = Math.max(0, Math.round(hours * 60));
  if (totalMinutes < 1) return "unter 1 min";
  const wholeHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (wholeHours === 0) return `${minutes} min`;
  if (minutes === 0) return `${wholeHours} h`;
  return `${wholeHours} h ${minutes} min`;
}

/**
 * Durchschnittliche Zeit pro gewartetem Objekt.
 * `projectHours` sind die auf das verknüpfte Projekt geschriebenen Zeiten,
 * `maintainedAssets` die abgeschlossenen Objekte dieser Wartung.
 */
export function averageTimePerAssetLabel(
  projectHours: number,
  maintainedAssets: number,
): AverageTimePerAssetLabel | null {
  if (!Number.isFinite(projectHours) || projectHours < 0) return null;
  if (!Number.isFinite(maintainedAssets) || maintainedAssets <= 0) return null;
  const objects = `${maintainedAssets} gewartete${maintainedAssets === 1 ? "s" : ""} Objekt${maintainedAssets === 1 ? "" : "e"}`;
  if (projectHours === 0) {
    return {
      label: "Noch keine Projektzeiten",
      detail: `${objects}, auf dem Projekt sind noch keine Zeiten geschrieben`,
    };
  }
  return {
    label: `Ø ${formatAverageDuration(projectHours / maintainedAssets)} je Objekt`,
    detail: `${formatDecimalHours(projectHours)} auf dem Projekt ÷ ${objects}`,
  };
}
